// Preview-only controls; no controls or saved menu state on the live store.
// See .skills/storefront/debug-ui.md.
window.__fudgeDebug?.action('Deschide meniul de categorii', () => document.querySelector('pq-category-menu')?.open());
window.__fudgeDebug?.action('Închide meniul de categorii', () => document.querySelector('pq-category-menu')?.close({ restoreFocus: true }));
document.querySelectorAll('pq-category-menu [data-pq-category]').forEach((button, index) => {
  window.__fudgeDebug?.action(`Deschide: ${button.textContent.trim()}`, () => {
    const menu = document.querySelector('pq-category-menu');
    menu?.open();
    menu?.showDetails(index);
  });
});
window.__fudgeDebug?.command('Previzualizează categoria', (index) => {
  const menu = document.querySelector('pq-category-menu');
  menu?.open();
  menu?.showDetails(Number(index));
  return { open: menu?.isOpen(), category: menu?.activeIndex };
});

if (!customElements.get('pq-category-menu')) {
  customElements.define(
    'pq-category-menu',
    class PixQualityCategoryMenu extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.trigger = this.querySelector('[data-pq-menu-trigger]');
        this.dropdown = this.querySelector('[data-pq-menu-dropdown]');
        this.closeButton = this.querySelector('[data-pq-menu-close]');
        this.backdrop = this.querySelector('[data-pq-menu-backdrop]');
        this.gridView = this.querySelector('[data-pq-category-grid-view]');
        this.categoryGrid = this.querySelector('[data-pq-category-grid]');
        this.details = this.querySelector('[data-pq-category-details]');
        this.backButton = this.querySelector('[data-pq-category-back]');
        this.categoryButtons = Array.from(this.querySelectorAll('[data-pq-category]'));
        this.panels = Array.from(this.querySelectorAll('[data-pq-category-panel]'));
        this.activeIndex = 0;

        if (!this.trigger || !this.dropdown) return;

        this.handleTriggerClick = () => this.toggle();
        this.handleCloseClick = () => this.close({ restoreFocus: true });
        this.handleBackClick = () => this.showGrid({ focus: true });
        this.handleDocumentKeydown = (event) => {
          if (event.key !== 'Escape' || !this.isOpen()) return;

          event.preventDefault();
          this.close({ restoreFocus: true });
        };
        this.handleResize = () => {
          if (window.innerWidth < 1024 && this.isOpen()) this.close();
        };

        this.trigger.addEventListener('click', this.handleTriggerClick);
        this.closeButton?.addEventListener('click', this.handleCloseClick);
        this.backdrop?.addEventListener('click', this.handleCloseClick);
        this.backButton?.addEventListener('click', this.handleBackClick);
        document.addEventListener('keydown', this.handleDocumentKeydown);
        window.addEventListener('resize', this.handleResize);

        this.categoryHandlers = this.categoryButtons.map((button, index) => {
          const click = () => this.showDetails(index);
          const keydown = (event) => this.handleCategoryKeydown(event, index);

          button.addEventListener('click', click);
          button.addEventListener('keydown', keydown);

          return { button, click, keydown };
        });

        this.showGrid();
        if (window.__fudgeDebug && window.innerWidth >= 1024) {
          try {
            const saved = JSON.parse(sessionStorage.getItem(`truva-menu:${this.dataset.sectionId}`) || 'null');
            if (saved?.open) {
              this.open();
              if (Number.isInteger(saved.category)) this.showDetails(saved.category);
            }
          } catch (_) { /* An unavailable storage area must not prevent navigation. */ }
        }
      }

      savePreviewState() {
        if (!window.__fudgeDebug) return;
        try {
          sessionStorage.setItem(`truva-menu:${this.dataset.sectionId}`, JSON.stringify({
            open: this.isOpen(), category: this.gridView?.hidden ? this.activeIndex : null
          }));
        } catch (_) { /* Preview state is optional. */ }
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.handleTriggerClick);
        this.closeButton?.removeEventListener('click', this.handleCloseClick);
        this.backdrop?.removeEventListener('click', this.handleCloseClick);
        this.backButton?.removeEventListener('click', this.handleBackClick);
        document.removeEventListener('keydown', this.handleDocumentKeydown);
        window.removeEventListener('resize', this.handleResize);

        this.categoryHandlers?.forEach(({ button, click, keydown }) => {
          button.removeEventListener('click', click);
          button.removeEventListener('keydown', keydown);
        });

        document.documentElement.classList.remove('pq-category-menu-open');
      }

      isOpen() {
        return this.trigger?.getAttribute('aria-expanded') === 'true';
      }

      toggle() {
        if (this.isOpen()) {
          this.close({ restoreFocus: true });
        } else {
          this.open();
        }
      }

      open() {
        this.showGrid();
        this.dropdown.hidden = false;
        this.trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('pq-category-menu-open');

        this.savePreviewState();
        window.requestAnimationFrame(() => {
          if (this.isOpen() && !this.gridView.hidden) this.categoryButtons[0]?.focus({ preventScroll: true });
        });
      }

      close({ restoreFocus = false } = {}) {
        this.showGrid();
        this.dropdown.hidden = true;
        this.trigger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('pq-category-menu-open');

        this.savePreviewState();
        if (restoreFocus) this.trigger.focus({ preventScroll: true });
      }

      showDetails(index) {
        if (index < 0 || index >= this.categoryButtons.length) return;

        this.activeIndex = index;
        this.gridView.hidden = true;
        this.details.hidden = false;

        this.categoryButtons.forEach((button, buttonIndex) => {
          button.setAttribute('aria-expanded', buttonIndex === index ? 'true' : 'false');
        });

        this.panels.forEach((panel, panelIndex) => {
          panel.hidden = panelIndex !== index;
        });

        this.savePreviewState();
        this.backButton?.focus({ preventScroll: true });
      }

      showGrid({ focus = false } = {}) {
        if (this.gridView) this.gridView.hidden = false;
        if (this.details) this.details.hidden = true;

        this.categoryButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
        this.panels.forEach((panel) => {
          panel.hidden = true;
        });

        if (focus) {
          this.savePreviewState();
          this.categoryButtons[this.activeIndex]?.focus({ preventScroll: true });
        }
      }

      handleCategoryKeydown(event, currentIndex) {
        const handledKeys = ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp', 'Home', 'End'];
        if (!handledKeys.includes(event.key)) return;

        event.preventDefault();
        const columnCount = Math.max(
          1,
          getComputedStyle(this.categoryGrid).gridTemplateColumns.split(' ').filter(Boolean).length
        );
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') nextIndex = currentIndex + 1;
        if (event.key === 'ArrowLeft') nextIndex = currentIndex - 1;
        if (event.key === 'ArrowDown') nextIndex = currentIndex + columnCount;
        if (event.key === 'ArrowUp') nextIndex = currentIndex - columnCount;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.categoryButtons.length - 1;

        nextIndex = Math.min(Math.max(nextIndex, 0), this.categoryButtons.length - 1);
        this.categoryButtons[nextIndex]?.focus();
      }
    }
  );
}
